export const blockIconsActivitiesCampingNew = (
	<span className='material-symbols-outlined'>camping</span>
);
